import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GstInvoiceService {

  constructor(private apiService: ApiService) { }

  getGstInvoices(queryParams?: HttpParams) {
    return this.apiService.get('gst-invoices', queryParams);
  }
  
  createGstInvoice(data: any) {
    return this.apiService.post('gst-invoices', data);
  }

  getGstInvoice(id: any) {
    return this.apiService.get('gst-invoices/' + id);
  }

  updateGstInvoice(id: any, data: any) {
    return this.apiService.update('gst-invoices/' + id, data);
  }

  deleteGstInvoice(id: any) {
    return this.apiService.delete('gst-invoices/' + id);
  }

  getNextInvoiceNumber(){
    return this.apiService.get('gst-invoices/next-number');
  }

  sendGstInvoiceToWhatsapp(payload: any) {
    return this.apiService.post('whatsapp/send-pdf', payload);
  }
}
